import { HasOnboardingDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useHasOnboardingProcess = () => {
  const { data, loading } = useQuery(HasOnboardingDocument, {})

  const hasOnboarding = data?.onboarding._policies.sidebarSeeOnboardingTopLevelItem.can

  return {
    loading,
    hasOnboarding,
  }
}
